import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function TopHeader({ title, subtitle, showBackButton, backPath, children }) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between mb-5 pb-4 border-b border-slate-200" data-testid="top-header">
      <div>
        {showBackButton && (
          <button
            onClick={() => backPath ? navigate(backPath) : navigate(-1)}
            className="flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-2 text-sm transition-all"
            data-testid="back-button"
          >
            <ArrowLeft size={16} />
            Back
          </button>
        )}
        {title && <h1 className="text-2xl font-bold text-slate-900" data-testid="page-title">{title}</h1>}
        {subtitle && <p className="text-slate-500 text-sm">{subtitle}</p>}
      </div>
      {children && (
        <div className="flex items-center gap-3">
          {children}
        </div>
      )}
    </div>
  );
}
